<template>
  <div :class="lang === 'en' ? 'en' : 'cn'">
    <div class="jc-page-header">
      <h1>
        <span>{{ $t('抵扣明细') }}</span>
      </h1>
    </div>
    <div class="jc-page-content">
      <div class="jc-container-table">
        <div class="jc-container-table-actionBar">
          <jc-form
            class="jc-table-actionBar-item"
            style="width: 100%"
            :inline="true"
          >
            <jc-form-item :label="$t('类型：')">
              <jc-select v-model="form.reservedInstanceType">
                <jc-option
                  v-for="item in productLineList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></jc-option>
              </jc-select>
            </jc-form-item>
            <jc-form-item :label="$t('实例抵扣券ID：')">
              <jc-input
                v-model="form.reservedInstanceId"
                :placeholder="$t('请输入实例抵扣券ID')"
              ></jc-input>
            </jc-form-item>
            <jc-form-item :label="$t('抵扣实例ID：')">
              <jc-input
                v-model="form.instanceId"
                :placeholder="$t('请输入抵扣实例ID')"
              ></jc-input>
            </jc-form-item>
            <jc-form-item :label="$t('抵扣时间：')" style="margin-left:0px">
              <jc-date-picker
                v-model="daterange"
                :editable="false"
                type="daterange"
                :placeholder="'选择日期范围'"
                clearable
              ></jc-date-picker>
            </jc-form-item>
            <jc-form-item>
              <jc-button type="primary" @click="search">{{
                $t('查询')
              }}</jc-button>
            </jc-form-item>
            <a href="javascript:void(0)" @click="exportList" class="export">{{
              $t('导出')
            }}</a>
          </jc-form>
        </div>
        <jc-table :data="tableData" class="loading-table">
          <jc-table-column
            prop="reservedInstanceId"
            :label="$t('实例抵扣券ID')"
          >
            <template scope="scope">{{
              scope.row.reservedInstanceId | filterParams
            }}</template>
          </jc-table-column>
          <jc-table-column prop="reservedInstanceTypeName" :label="$t('类型')">
            <template scope="scope">{{
              scope.row.reservedInstanceTypeName | filterParams
            }}</template>
          </jc-table-column>
          <jc-table-column
            prop="instanceServiceCodeName"
            :label="$t('抵扣产品')"
          >
            <template scope="scope">{{
              scope.row.instanceServiceCodeName | filterParams
            }}</template>
          </jc-table-column>
          <jc-table-column prop="instanceId" :label="$t('实例ID')">
            <template scope="scope">{{
              scope.row.instanceId | filterParams
            }}</template>
          </jc-table-column>
          <jc-table-column prop="usageTime" :label="$t('抵扣时间')">
            <template scope="scope">{{
              scope.row.usageTime | filterParams
            }}</template>
          </jc-table-column>
          <jc-table-column prop="consumeAmount" :label="$t('抵扣量')">
            <template scope="scope">{{
              splitUnitTranslation(scope.row.consumeAmount)
            }}</template>
          </jc-table-column>
          <jc-table-column prop="instanceSpec" :label="$t('实例规格')">
            <template scope="scope">{{
              scope.row.instanceSpec | filterParams
            }}</template>
          </jc-table-column>
          <jc-table-column prop="instanceRegionName" :label="$t('实例地域')">
            <template scope="scope">{{
              $t(scope.row.instanceRegionName) | filterParams
            }}</template>
          </jc-table-column>
          <jc-table-column :label="$t('用量时间段')" min-width="160px">
            <template scope="scope"
              >{{ scope.row.startTime }} - {{ scope.row.endTime }}</template
            >
          </jc-table-column>
        </jc-table>
        <div class="jc-container-table-actionBar" v-if="totalCount > 0">
          <jc-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="form.pageNo"
            :page-sizes="[10, 20, 50]"
            :page-size="form.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></jc-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dicMixins from '@/mixins/dic-mixins'
import { getDate } from '@/utils'
import { getResourceUseList, exportUseList } from '@/api/instances-api'
import getTranslation from '@/i18n/getTranslation'
export default {
  name: 'use-list',
  props: [],
  components: {},
  mixins: [dicMixins],
  data() {
    return {
      form: {
        instanceId: '',
        reservedInstanceType: '',
        reservedInstanceId: '',
        pageSize: 10,
        pageNo: 1,
        startTime: '',
        endTime: ''
      },
      daterange: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date()
      ],
      tableData: [],
      totalCount: 0
    }
  },
  watch: {},
  computed: {},
  async mounted() {},
  created() {
    this.getList()
  },
  filters: {},
  methods: {
    // 分页更改
    handleSizeChange(val) {
      this.form.pageSize = val
      this.form.pageNo = 1
      this.getList()
    },
    // 分页更改
    handleCurrentChange(val) {
      this.form.pageNo = val
      this.getList()
    },
    search() {
      this.form.pageNo = 1
      this.getList()
    },
    handleTime() {
      if (this.daterange && this.daterange[0]) {
        this.form.startTime = getDate(this.daterange[0]).txt_ymdhms
        let temp = getDate(this.daterange[1]).txt_ymdhms
        this.form.endTime = temp.split(' ')[0] + ' 23:59:59'
      } else {
        this.form.startTime = ''
        this.form.endTime = ''
      }
    },
    // 获取列表
    async getList() {
      this.handleTime()
      const { result } = await getResourceUseList(this.form)
      this.tableData = result.result
      this.totalCount = result.pagination && result.pagination.numberRecords
    },
    async exportList() {
      this.handleTime()
      let reqData = Object.assign({}, this.form)
      delete reqData.pageSize
      delete reqData.pageNo
      const { result } = await exportUseList(reqData)
      let exportUrl
      if (!result.result) return
      exportUrl = result.result.replace(/^(http:|https:)/, '')

      window.open(exportUrl, '_blank')
    },
    splitUnitTranslation(amount) {
      if (amount) {
        const num = parseInt(amount)
        if (num) {
          const len = num.toString().length
          const unit = amount.slice(len)
          return `${num} ${getTranslation(unit)}`
        }
        return amount
      }
      return '--'
    }
  }
}
</script>
<style scoped>
.jc-form--inline .jc-form-item {
  margin-right: 20px;
}
.jc-button {
  width: 70px;
}
.export {
  margin-left: 20px;
  float: right;
  line-height: 30px;
}
</style>
